/**
import baseDialogMixin from "@/mixins/baseDialogMixin";
<base-dialog
@on-close="closeDialog"
@on-sure="sureDialog"
>
</base-dialog>
 */
import BaseDialog from '@/components/BaseDialog/base-dialog'
export default {
  components: {
    BaseDialog
  },
  data() {
    return {
      isShowDialog: false
    }
  },
  methods: {
    closeDialog() {
      this.isShowDialog = false
      this.$emit('on-close')
    },
    showDialog() {
      this.isShowDialog = true
    },
    sureDialog() {
      this.closeDialog()
    }
  }
}
